const BASE = "https://sprankelien.be";

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Praktijk Sprankelien",
  description:
    "Warme, professionele begeleiding voor kinderen in Ramsel. Speltherapie, kinderyoga en zomerkampen in een veilige, huiselijke sfeer.",
  url: BASE,
  telephone: "+32476796175",
  email: "hildenys@live.be",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Ramsel",
    addressLocality: "Herselt",
    addressRegion: "Antwerpen",
    postalCode: "2230",
    addressCountry: "BE",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 51.0667,
    longitude: 4.8833,
  },
  areaServed: [
    { "@type": "City", name: "Ramsel" },
    { "@type": "City", name: "Herselt" },
    { "@type": "City", name: "Aarschot" },
    { "@type": "City", name: "Westerlo" },
    { "@type": "City", name: "Scherpenheuvel-Zichem" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00",
    },
  ],
  priceRange: "€",
  sameAs: [],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Diensten",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Speltherapie & begeleiding",
          description: "Persoonlijke begeleiding voor kinderen bij emoties, stress en zelfvertrouwen in Ramsel.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kinderyoga",
          description: "Yoga en ontspanning voor kinderen in Ramsel — ademhaling, beweging en verbeelding.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Zomerkampen",
          description: "Avontuurlijke zomerkampen in de natuur voor kinderen van 6-12 jaar in Ramsel.",
        },
      },
    ],
  },
};

export const breadcrumb = (items: { name: string; path: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${BASE}${item.path}`,
  })),
});

export const serviceJsonLd = (name: string, description: string, url: string, price?: string) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${BASE}${url}`,
  areaServed: {
    "@type": "City",
    name: "Ramsel",
  },
  provider: {
    "@type": "LocalBusiness",
    name: "Praktijk Sprankelien",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Ramsel",
      addressRegion: "Antwerpen",
      addressCountry: "BE",
    },
  },
  ...(price ? { offers: { "@type": "Offer", price, priceCurrency: "EUR" } } : {}),
});

export const articleJsonLd = (title: string, excerpt: string, slug: string, date: string) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description: excerpt,
  url: `${BASE}/blog/${slug}`,
  datePublished: date,
  author: { "@type": "Person", name: "Hilde" },
  publisher: {
    "@type": "Organization",
    name: "Praktijk Sprankelien",
  },
});
